export const stringTokenReplacer = (value: string, tokens?: { [token: string]: string }): string => {
  // Replace the tokens in the string if any
  return tokens
    ? Object.entries(tokens).reduce(
        (valueReduced, [tokenKey, tokenValue]) => valueReduced.replace(`{${tokenKey}}`, tokenValue),
        value,
      )
    : value;
};
